<nz-skeleton [nzActive]="true" [nzLoading]="loading">
  <ng-container *ngIf="staticsInfo.length > 0">
    <div *ngFor="let stat of staticsInfo; let i = index">
      <div class="font-roboto-500 text-16 text-center">
        {{ stat.type.text }}
      </div>
      <div class="flex justify-between pb-2">
        <div class="w-full font-roboto-600 text-14">
          {{ stat.homeTeam }}{{ stat.type.code === 25 ? "%" : "" }}
          <nz-progress
            dir="rtl"
            [nzPercent]="stat.homeTeamPercentage"
            nzSize="small"
            [nzShowInfo]="false"
            [nzStrokeColor]="'#172C41'"
          >
          </nz-progress>
        </div>
        <div
          class="w-full text-red-2 font-roboto-600 text-14 text-end"
        >
          {{ stat.awayTeam }}{{ stat.type.code === 25 ? "%" : "" }}
          <nz-progress
            class="progress-right"
            [nzPercent]="stat.awayTeamPercentage"
            nzSize="small"
            [nzShowInfo]="false"
            [nzStrokeColor]="'#E20E17'"
          >
          </nz-progress>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    *ngIf="staticsInfo.length == 0"
    class="font-roboto-700 text-blue-o-50 bg-white my-4 p-4 max-sm:p-3 rounded-6 text-center max-sm:my-2"
  >
    {{ "NotAvalaibleInformation" | translate }}
  </div>
</nz-skeleton>
